import { render } from "./SpotRegistrationView.vue?vue&type=template&id=5045df5d"
import script from "./SpotRegistrationView.vue?vue&type=script&lang=js"
export * from "./SpotRegistrationView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__